import React, { useEffect } from 'react';

// redux
import { closeMenu } from 'store'
import { useDispatch } from 'react-redux';

// component
import Header from 'component/Header';
import SubHeader from 'component/SubHeader';
import Menu from 'component/Menu';
import Footer from 'component/Footer';
import FloorMap3 from 'component/FloorMap3';
import FloorMap4 from 'component/FloorMap4';

import './PageFloorMap.scss';

type Props = {
  testPath: string,
}

const PageFloorMap: React.FC<Props> = (props) => {

  // dispatch
  const dispatch = useDispatch();

  // Effect
  useEffect(() => {
    // タイトルなど
    // document.title = 'FLOORMAP';

    // ページ遷移時にメニューを閉じる
    return () => {
      dispatch(closeMenu());
    }
  });

  return (
    <div id="PageFloorMap">
      <Header />
      <Menu />
      <SubHeader active={1} />

      <div className="topTitle">
        <h2 className="c-h2">フロアマップから見る</h2>
      </div>

      <section id="floorMapFig4">
        <h3><p className="title">4F</p></h3>
        <FloorMap4 active={-1} />
      </section>

      <section id="floorMapFig3">
        <h3><p className="title">3F</p></h3>
        <FloorMap3 active={-1} />
      </section>

      <Footer />      
    </div>
  );
}

export default PageFloorMap;
